<template>
  <small class="font-weight-normal">{{ texto }}</small>
</template>

<script>
import moment from "moment";

export default {
  name: "DashboardLiveClock",
  data: function () {
    return {
      texto: "",
    };
  },
  created: function () {
    moment.locale("es");
    this.tick();
    this._timer = setInterval(this.tick, 1000);
  },
  beforeDestroy: function () {
    clearInterval(this._timer);
  },
  methods: {
    tick: function () {
      this.texto = moment(new Date()).format("D MMMM YYYY, h:mm:ss a");
    },
  },
};
</script>
